import { qoolApiService } from "./qoolApiService";
import { ICreateFileReportResult } from "models";

const routes = {
	getMdtDashboardPatientList: "api/report/GetMdtDashboardPatientList",
	getMdtDashboardExcludedPatientList: "api/report/GetMdtDashboardExcludedPatientList",
	getBreastIndicatorPatientList: "api/report/GetBreastIndicatorPatientList",
	getLungIndicatorPatientList: "api/report/GetLungIndicatorPatientList",
	getCRCIndicatorPatientList: "api/report/GetCRCIndicatorPatientList",
	getBrainIndicatorPatientList: "api/report/GetBrainIndicatorPatientList",
	getHeadAndNeckIndicatorPatientList: "api/report/GetHeadAndNeckIndicatorPatientList",
	getYouthCancerIndicatorPatientList: "api/report/GetYouthCancerIndicatorPatientList",
	getAMLIndicatorPatientList: "api/report/GetAMLIndicatorPatientList"
};

interface IReportViewModel {

}

export class ReportApi {
	static getMdtDashboardPatientList(referralIdCsvOrAll: string, allData: boolean) {
		return qoolApiService.post(routes.getMdtDashboardPatientList, { referralIdCsvOrAll, allData }) as Promise<ICreateFileReportResult>
	}

	static getMdtDashboardExcludedPatientList(excludedReferralIdCsv: string, allData: boolean) {
		return qoolApiService.post(routes.getMdtDashboardExcludedPatientList, { excludedReferralIdCsv, allData }) as Promise<ICreateFileReportResult>
	}

	static getBreastIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getBreastIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}

	static getLungIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getLungIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}

	static getCRCIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getCRCIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}
	
	static getBrainIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getBrainIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}

	static getHeadAndNeckIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getHeadAndNeckIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}

	static getYouthCancerIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getYouthCancerIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}

	static getAMLIndicatorPatientList(referralIdCsvOrAll: string, allData: boolean, extractTypeId: number) {
		return qoolApiService.post(routes.getAMLIndicatorPatientList, { referralIdCsvOrAll, allData, extractTypeId }) as Promise<ICreateFileReportResult>
	}
}

export default ReportApi;
